import { render, staticRenderFns } from "./AddStoreIssue.vue?vue&type=template&id=54fcd4d4&"
import script from "./AddStoreIssue.vue?vue&type=script&lang=js&"
export * from "./AddStoreIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports